import { render, staticRenderFns } from "./CodeDetail.vue?vue&type=template&id=2ae14e61"
import script from "./CodeDetail.vue?vue&type=script&lang=js"
export * from "./CodeDetail.vue?vue&type=script&lang=js"
import style0 from "./CodeDetail.vue?vue&type=style&index=0&id=2ae14e61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports